module.exports = __webpack_public_path__ + "static/media/2 (9).b2ff7f29.jpg";